import * as React from "react";
const SvgLeftArrow = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "Icon" }, /* @__PURE__ */ React.createElement("path", { id: "icon", d: "M16.6673 9.16634H6.52565L11.184 4.50801L10.0007 3.33301L3.33398 9.99967L10.0007 16.6663L11.1757 15.4913L6.52565 10.833H16.6673V9.16634Z", fill: "#48454F" })));
export default SvgLeftArrow;
